export default __webpack_public_path__ + "static/media/Location_BG.3ecbef0f.jpg";